export default {
  NAVIGATION: {
    TITLE: 'wokapIA',
    SHORTS_TITLE: 'wokapIA',
    PREVIOUS_CANDIDATE: 'Previous candidate',
    NEXT_CANDIDATE: 'Next candidate',
    NO_MORE_CANDIDATES: 'No more candidates to show. Clear the filters to see all candidates.',
    ADD_TO_SELECTION: 'Add to selection',
    SELECTED: 'Selected',
    SKILLS_SECTION_TITLE: 'Skills, Abilities and Language',
    HEADER_TITLE: 'Discover your next candidate',
    // \n = forced line break (rendered with white-space: pre-line)
    HEADER_SUBTITLE: 'Browse the wokap network and\napply filters to find specific profiles.',
    NETWORK_STATUS_PROFILES: 'profiles',
    NETWORK_STATUS_AVAILABLE: 'currently available.',
    // Compact header badge shown only while browsing the whole network (no filters/search applied)
    NETWORK_TOTAL_AVAILABLE: 'Candidates available',
    NO_CANDIDATES: 'No candidates match these filters.',
    CANDIDATES_SELECTED: 'candidates selected',
    CANDIDATE_SELECTED: 'candidate selected',
    REMOVE_FROM_SELECTION: 'Remove from selection',
    CANDIDATES_FILTERED: 'candidates filtered',
    CANDIDATE_FILTERED: 'candidate filtered',
    CLEAR_FILTERS_ARIA: 'Clear filters',
    CANDIDATE_SEARCH_PLACEHOLDER: 'Search candidate...',
    CREATE_OFFER: 'Create folder',
    CREATE_OFFER_TOOLTIP: 'Create an offer to invite these candidates to apply to your job offer',
    CREATE_OFFER_TOOLTIP_EMPTY: 'Select one or more candidates to create an offer and invite them to apply to it.',
    CLEAR_SELECTION: 'Deselect',
    NOT_ENROLLED_CV_TOOLTIP: 'This person hasn\'t applied to the offer yet. Invite them, and once they apply, you\'ll be able to see their full profile.',
    PANEL_COLLAPSE: 'Collapse',
    PANEL_EXPAND: 'Expand',
    INFO_PANEL_TITLE: 'Candidate Info',
    // Placeholder used instead of the real name in the info panel's empty-state lines
    // (e.g. "The candidate has not registered any hard skills.")
    EMPTY_STATE_NAME: 'The candidate',
    // Shown by PreventDirtyFormGuard when leaving the page with candidates still selected
    EXIT_GUARD_TITLE: 'You have selected candidates',
    EXIT_GUARD_MESSAGE: 'If you leave now you will lose the selection. Create a folder to save it before leaving.',
    EXIT_GUARD_ACCEPT: 'Leave without saving',
    EXIT_GUARD_REJECT: 'Stay',
  },
};
